import styled from 'styled-components'

import LiveSearchBar from 'plugin-liverig/shared/components/SearchBar'

export const SearchBar = styled(LiveSearchBar)<{ width?: string }>`
    width: ${({ width }) => (width ? width : 'unset')};
`
